import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TimeAgoComponent from "../tools/TimeAgoComponent";
import { useGetNotificationsQuery } from "../../store/api/notificationApi";

export default function Header() {
  const [notification, setNotifications] = useState([]);
  const { data, refetch } = useGetNotificationsQuery();

  useEffect(() => {
    if (data) {
      setNotifications(data);
    }
  }, [data]);

  const handleRefresh = () => {
    refetch();
  };

  function insertNewlines(text, maxLength) {
    let result = '';
    for (let i = 0; i < text.length; i += maxLength) {
      result += text.substr(i, maxLength) + '\n';
    }
    return result;
  }
  
  

  return (
    <div>
      <header id="page-header">
        <div className="content-header">
          <div className="content-header-section">
            <button
              type="button"
              className="btn btn-circle btn-dual-secondary"
              data-toggle="layout"
              data-action="sidebar_toggle"
              onClick={handleRefresh}
            >
              <i className="fa fa-navicon"></i>
            </button>
          </div>

          <div className="content-header-section">
            <div className="btn-group" role="group">
              <button
                type="button"
                className="btn  position-relative  me-3"
                id="page-header-notifications"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="fa fa-bell fs-4"></i>
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  {notification?.length}
                </span>
              </button>
              <div
                className="dropdown-menu dropdown-menu-right min-width-300"
                aria-labelledby="page-header-notifications"
              >
                <h5 className="h6 text-center py-10 mb-0 border-b text-uppercase">
                  Notifications
                </h5>
                <ul className="list-unstyled my-20">
                  {notification?.length > 0 ? (
                    notification?.slice(0, 3).map((data) => {
                      return (
                        <li>
                          <Link
                            className="text-body-color-dark media mb-15  text-decoration-none"
                            to="/notifications"
                          >
                            <div className="ml-5 mr-15">
                              <i className="fa fa-fw fa-exclamation-triangle text-warning"></i>
                            </div>
                            <div className="media-body pr-10">
                              <p className="mb-0">
                                {/* <span className="fw-bolder">{data.name}</span>{" "} */}
                                <p className="mb-0">{data.text}!</p>
                              </p>
                              <div className="text-muted font-size-sm font-italic d-flex">
                                <div
                                  className={
                                    data.qty > 0
                                      ? "spinner-grow  text-warning me-1 "
                                      : "spinner-grow  text-danger me-1 "
                                  }
                                  style={{ width: "10px", height: "10px" }}
                                  role="status"
                                >
                                  <span className="sr-only ">Loading...</span>
                                </div>
                                {<TimeAgoComponent givenDate={data.date} />}
                              </div>
                            </div>
                          </Link>
                        </li>
                      );
                    })
                  ) : (
                    <div className="text-muted font-size-sm font-italic text-center">
                      there is no any product notification
                    </div>
                  )}
                </ul>
                <div className="dropdown-divider"></div>
                <Link
                  className="dropdown-item text-center mb-0"
                  to="/notifications"
                  onClick={handleRefresh}
                >
                  <i className="fa fa-flag mr-5"></i> View All
                </Link>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}
